import { Menu } from 'antd'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { CINEMA_UI_URL } from '../../common/config'

import MovieIcon from '../../icons/movie.svg'
import ProfileIcon from '../../icons/profile.svg'
import TheatreWhiteIcon from '../../icons/theatre-white.svg'

const SubMenu = Menu.SubMenu
const navLabelClass = 'nav-label block qw-center qw-font-size-small qw-line-height-small qw-bold qw-color-text-inverse-body qw-capitalize'

class NavMenu extends React.Component {

  constructor () {
    super()
    this.state = {
      selectedKeys: ['movies']
    }
  }

  getNavUser () {
    const {user_first_name, user_last_name} = this.props.user
    return (
      <span><ProfileIcon className="qw-icon-large qw-ml-auto qw-mr-auto block qw-mt-xx-small"/> <p
        className={navLabelClass}>{user_first_name} {user_last_name}</p></span>)
  }

  redirect (e) {
    switch (e.key) {
      case 'manage':
        window.location = CINEMA_UI_URL
        break
      case 'logout':
        window.location = CINEMA_UI_URL
        break
      default:
        return
    }
  }

  render () {
    return (
      <Menu mode="horizontal" className="nav-menu qw-border-none right"
            selectedKeys={this.state.selectedKeys} onClick={this.redirect}>
        <Menu.Item key="movies" className="nav-menu-item">
          <MovieIcon className="qw-icon-large qw-ml-auto qw-mr-auto block qw-mt-xx-small"/>
          <p className={navLabelClass}>{I18n.t('navMenu.movies')}</p>
        </Menu.Item>
        <Menu.Item key="manage" className="nav-menu-item">
          <TheatreWhiteIcon className="qw-icon-large qw-ml-auto qw-mr-auto block qw-mt-xx-small"/>
          <p className={navLabelClass}>{I18n.t('navMenu.manage')}</p>
        </Menu.Item>
        <SubMenu title={this.getNavUser()} className="nav-menu-item">
          <Menu.Item key="logout">{I18n.t('navMenu.logout')}</Menu.Item>
        </SubMenu>
      </Menu>
    )
  }
}

export default NavMenu



// WEBPACK FOOTER //
// ./src/app/components/common/NavMenu.js